import React from "react";
import AppCard from "@crema/core/AppCard";
import Slider from "react-slick";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import MediaSlider from "./MediaSlider";
import { Link, Typography, alpha } from "@mui/material";
import { Fonts } from "shared/constants/AppEnums";
import { textEllipsis } from "@crema/utility/Utils";
const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const SlideBasicArrow = ({ data }) => {
    return (
        <AppCard
            contentStyle={{
                p: 2,
                "&:last-of-type": {
                    pb: "8px !important",
                },
            }}
        >
            <MediaSlider>
                <Slider {...settings}>
                    {data.map((slide, index) => (
                        <Box
                            key={index}
                            sx={{
                                position: "relative",
                                maxHeight: { xs: 260, md: 320 },
                                minHeight: { xs: 250, md: 310 },
                            }}
                            component={Link}
                            href={`news/${slide.newsId}`}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    height: "100%",
                                    width: "100%",
                                    "& img": {
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "cover",
                                        height: "100%",
                                        width: "100%",
                                    },
                                }}
                            >
                                <img
                                    src={slide.filename}
                                    alt={slide.newsTitle}
                                    title={slide.newsTitle}
                                />
                            </Box>
                            <Box
                                sx={{
                                    py: 3,
                                    px: 4,
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    zIndex: 1,
                                    backgroundColor: (theme) =>
                                        alpha(theme.palette.common.black, 0.65),
                                    borderBottomLeftRadius: "10px",
                                    borderBottomRightRadius: "10px",
                                    color: (theme) =>
                                        theme.palette.common.white,
                                }}
                            >
                                <Typography
                                    component="h3"
                                    sx={{
                                        fontSize: 16,
                                        fontWeight: Fonts.SEMI_BOLD,
                                        mb: 3,
                                    }}
                                >
                                    {textEllipsis(slide.newsTitle, 35)}
                                </Typography>
                                <Typography
                                    component="h4"
                                    sx={{
                                        fontSize: 12,
                                        fontWeight: Fonts.SEMI_BOLD,
                                        mb: 3,
                                    }}
                                >
                                    {textEllipsis(slide.newsDescription, 125)}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Slider>
            </MediaSlider>
        </AppCard>
    );
};

export default SlideBasicArrow;

SlideBasicArrow.propTypes = {
    data: PropTypes.array,
};

{
    /* <Box
sx={{
  position: 'relative',
  height: '100%',
}}
>
<Box
  sx={{
    position: 'relative',
    maxHeight: {xs: '100%', md: 320},
    minHeight: {xs: 250, md: '100%'},
    height: '100%',
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  }}
>
  <img src={slide.srcImg} alt={slide.title} />
</Box>
<Box
  sx={{
    py: 3,
    px: 4,
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    backgroundColor: (theme) => alpha(theme.palette.common.black, 0.65),
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
    color: (theme) => theme.palette.common.white,
  }}
>
  <Typography
    component='h3'
    sx={{
      fontSize: 16,
      fontWeight: Fonts.SEMI_BOLD,
      mb: 3,
    }}
  >
    {slide.title}
  </Typography>
</Box>
</Box> */
}
